import { Box, Button, TextField, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useState } from "react";

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        gridGap: "4px",
        flexWrap: "wrap",
        width: "100%",
        marginTop: theme.spacing(1)
    }
}));

interface Props
{
    updateComment: (comment: string) => void
    editMode: boolean
    setEditMode: (edit: boolean) => void
    commentText: string
}

export default function EditableComment({ commentText, editMode, setEditMode, updateComment }: Props)
{
    const classes = useStyles();
    const [comment, setComment] = useState(commentText);
    const handleOnClickSave = () =>
    {
        if (commentText !== comment)
        {
            setEditMode(false);
            updateComment(comment);
        }
    }
    const handleOnClickCancel = () =>
    {
        if (commentText !== comment)
        {
            setComment(commentText);
        }
        setEditMode(false);
    }
    return <Box>
        {editMode ?
            <Box className={classes.container}>
                <TextField multiline fullWidth value={comment} variant={"outlined"} size={"small"} onChange={(event) => { setComment(event.currentTarget.value); }} />
                <Box>
                    <Button variant="contained" size={"small"} color={"primary"} onClick={handleOnClickSave} disabled={comment === commentText}>Save</Button>
                </Box>
                <Box>
                    <Button variant="contained" size={"small"} color={"primary"} onClick={handleOnClickCancel}>Cancel</Button>
                </Box>
            </Box> :
            <Typography variant={"body2"}>{comment}</Typography>
        }
    </Box>
}